<template>
  <div class="customerSelect">
    <collapsePanel title="片区">
      <template slot="title">
        <span>大片区/小片区</span>
      </template>
      <cascaderPanel @get-product-data="cascaderClick" :config="{ firstId: 'parentDomainID' }" :leftArgs="{url: '/Account/domainDefine/getDomainListForVue.html'}" :rightArgs="{url: '/Account/domainDefine/getSmallDomainListForVue.html', isPage: 'N'}"></cascaderPanel>
    </collapsePanel>
    <tabs isHideNav>
      <el-card slot="card" shadow="never">
        <slideForm>
          <el-form size="small" inline @submit.native.prevent>
            <el-form-item>
              <el-input placeholder="输入客户名称查询" v-model="params.keyWords" @keydown.enter.right.native="queryProduct" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="queryProduct">查询</el-button>
            </el-form-item>
          </el-form>
          <el-form size="small" inline>
            <el-form-item>
              <span style="font-size: 12px;color: rgb(245, 108, 108);">已选：{{selectProductList.length}}个</span>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="postProductMessage">确定</el-button>
            </el-form-item>
          </el-form>
        </slideForm>
      </el-card>
      <template>
        <el-table ref="table" size="mini" :row-key="getRowKey" v-loading="tableIsLoading" :data="productList" border stripe height="100%" max-height="100%" @selection-change="handleSelectionChange" :highlight-current-row="!multiple" @current-change="handleTableCurrentChange" @row-click="handleTableRowClick">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column type="selection" width="50" reserve-selection v-if="multiple"></el-table-column>
          <el-table-column label="客户名称" prop="text"></el-table-column>
          <el-table-column label="建档日期" prop="entryDateTime">
            <template slot="header">
              <el-popover placement="bottom" trigger="click" ref="popover_date" @show="popoverShow('date')">
                <div class="query_btn_group">
                  <date-picker v-model="queryInfo.date.selected" type="daterange" align="right"
                    unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                    :picker-options="queryInfo.pickerOptions">
                  </date-picker>
                  <el-button type="text" @click="tableFilter('date')">筛选</el-button>
                </div>
                <div slot="reference" :class="['reference', queryInfo.date.isFilter ? 'highlight' : '' ]"><label>建档日期</label><i class='el-icon-arrow-down'></i></div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="pagination">
        <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper" :total="productTotal"></el-pagination>
        <div class="selectProductWrap">
          <span>已选客户:</span>
          <ul class="selectProduct">
            <el-scrollbar>
              <span v-for="(item, index) in selectProductList" :key="item.index">{{index ? (',' + item.text) : item.text}}</span>
            </el-scrollbar>
          </ul>
        </div>
      </template>
    </tabs>
  </div>
</template>

<script>
import cascaderPanel from '@/components/common/cascaderPanel.vue'
import collapsePanel from '@/components/common/collapsePanel.vue'
import tabs from '@/components/common/tabs.vue'
import slideForm from '@/components/common/slideForm.vue'
import datePicker from '@/components/common/datePicker.vue'
import { pickerOptions, getNowFormatDate, getAddDate } from '@/assets/js/common.js'
export default {
  name: 'customerSelect',
  components: {
    collapsePanel,
    cascaderPanel,
    slideForm,
    datePicker,
    tabs
  },
  props: {
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    },
    defaultDisabledKeys: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      params: {
        keyWords: '',
        page: 1,
        size: 10
      },
      productTotal: 0,
      tableIsLoading: false,
      productList: [],
      selectProductList: [],
      queryInfo: {
        date: { selected: [getAddDate(-3), getNowFormatDate()], isFilter: false },
        pickerOptions: pickerOptions
      },
    };
  },
  created() {
    // 多选默认选中
    this.$nextTick(()=>{
      if (this.multiple) {
        this.defaultCheckedKeys.forEach(item=>{
          this.$refs.table.toggleRowSelection(item);
        })
      } else {
        this.$refs.table.setCurrentRow(this.defaultCheckedKeys[0]);
      }
    })
    this.getProductData()
    console.log(this.defaultCheckedKeys)
  },
  methods: {
    handleSelectionChange(val) {
      this.selectProductList = val
    },
    // 监听pagesize的改变
    handleSizeChange(newSize) {
      this.params.size = newSize
      this.getProductData()
    },
    // 监听页码值的改变
    handleCurrentChange(newPage) {
      this.params.page = newPage
      this.getProductData()
    },
    getRowKey(row) {
      return row.value
    },
    cascaderClick({ row, leaf }) {
      if (!leaf) {
        this.params.domainID = (row.value == 'all' ? '' : row.value)
        this.params.smallDomainID = ''
      } else {
        this.params.smallDomainID = (row.value == 'leafAll' ? '' : row.value)
      }
      this.queryProduct()
    },
    queryProduct() {
      this.params.page = 1
      this.getProductData()
    },
    async getProductData() {
      this.tableIsLoading = true
      const { data: res } = await this.$http.post(
        '/Account/customerDefine/getCustomerListForVue.html',
        this.Qs.stringify(this.params)
      );
      this.tableIsLoading = false
      res.result = JSON.parse(res.result)
      this.productList = JSON.parse(res.result.data)
      this.productTotal = res.result.total
    },
    popoverShow(tag) {
      const popover = this.$refs['popover_' + tag]
      popover.$nextTick(() => {
        popover.$children[0].focus()
      })
    },
    // 其他自定义筛选
    tableFilter (tag) {
      this.$refs['popover_' + tag].doClose()
      let item = this.queryInfo[tag]
      if (tag == 'date') {
        if (item.selected) {
          item.isFilter = true
          this.params.beginDate = item.selected[0]
          this.params.endDate = item.selected[1]
        } else {
          item.isFilter = false
          this.params.beginDate = ''
          this.params.endDate = ''
        }
      }
      this.queryProduct()
    },
    postProductMessage() {
      this.$emit('get-customer', this.selectProductList)
    },
    handleTableCurrentChange(currentRow) {
      if (this.multiple) return false
      this.selectProductList = [currentRow]
    },
    handleTableRowClick(currentRow) {
      if (this.multiple) return false
      this.selectProductList = [currentRow]
      this.postProductMessage()
    }
  },
};
</script>

<style lang="less" scoped>
.customerSelect {
  display: flex;
  flex: 1;
  flex-basis: auto;
  overflow: auto;
  box-sizing: border-box;
  min-width: 0;
  height: 100%;
  .collapsePanel{
    flex-shrink: 0;
  }
  ::v-deep .tabs {
    margin-left: 12px;
    .tabs-header {
      .el-card {
        .el-card__body {
          // padding-top: 0;
          .slideForm {
            padding: 0;
            flex-wrap: wrap;
            .slideForm-main {
              align-items: center;
              justify-content: space-between;
            }
            .el-form {
              display: flex;
              margin: 0;
              .el-form-item + .el-form-item {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
    .el-table {
      .index {
        div {
          padding: 0;
          text-align: center;
        }
      }
    }
    .selectProductWrap {
      display: flex;
      & > span {
        flex-shrink: 0;
        margin-right: 50px;
      }
      .selectProduct {
        height: 50px;
        flex: 1;
        .el-scrollbar {
          height: 100%;
        }
      }
    }
  }
}
</style>
